import { FC, useCallback } from 'react'
import { useTranslation } from '../../../../hooks/useTranslation'
import { Trans } from 'react-i18next'
import STRATEGIC_IMG from '../assets/img/strategic.png'
import STRATEGIC_IMG_VN from '../assets/img/strategic_vn.png'
import STRATEGIC_IMG_BG_LEFT from '../assets/img/strategic_bg_left.png'
import STRATEGIC_IMG_BG_RIGHT from '../assets/img/strategic_bg_right.png'

import Image from 'next/image'
import useMixpanel from '../../../../hooks/useMixpanel'

const Strategic: FC<{ setIsLazyLoading?; getRef?; getRefMobile? }> = ({ setIsLazyLoading, getRef, getRefMobile }) => {
  const { translate, currentLanguage } = useTranslation()
  const Mixpanel = useMixpanel()
  const handleScrollToSection = useCallback(() => {
    // console.log(contactRef.current)
    setIsLazyLoading(false)
    return Promise.all([
      getRef()?.then((targetRef) => {
        targetRef?.current?.scrollIntoView()
      }),

      getRefMobile()?.then((targetRef) => {
        targetRef?.current?.scrollIntoView()
      })
    ]).then(() => {
      return
    })
  }, [])
  return (
    <div className="strategic">
      <div className="strategic-bg-left">
        <Image src={STRATEGIC_IMG_BG_LEFT} placeholder="blur" alt="img_right" width={637} height={1002} />
      </div>
      <div className="strategic-bg-right">
        <Image src={STRATEGIC_IMG_BG_RIGHT} placeholder="blur" alt="img_right" width={344} height={1002} />
      </div>
      <div className="strategic-content">
        <div className="strategic-heading-wrapper">
          <div>
            <h2 className="strategic-heading">
              <Trans i18nKey="page_employer_headhunt_service:strategic_title">
                <span />
              </Trans>
            </h2>
            <div className="strategic-sub-title">{translate('page_employer_headhunt_service:strategic_des')}</div>
          </div>
          <div className="text-center">
            <a
              id="button_book_a_consultation_1"
              data-mixpanel-event={Mixpanel.EVENTS.CLICK_BOOK_A_CONSULTANT}
              className="btn-book-consultation"
              onClick={() => handleScrollToSection()}>
              {translate('page_employer_headhunt_service:lp_book_a_consultation')}
            </a>
          </div>
        </div>

        <div className="strategic-col">
          <div>
            <Image
              src={currentLanguage === 'en' ? STRATEGIC_IMG : STRATEGIC_IMG_VN}
              placeholder="blur"
              alt="img_right"
              width={679}
              height={540}
            />
          </div>
          <div className="strategic-col-content-wrapper">
            {[1, 2, 3, 4, 5].map((index) => (
              <div key={`strategic-${index}`} className="strategic-col-content">
                <Trans i18nKey={`page_employer_headhunt_service:strategic_${index}`}>
                  <span />
                </Trans>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Strategic
